import{jsx as a}from"react/jsx-runtime";import{withVDSManager as t}from"@vds-core/utilities";import{ColorTokens as e}from"@vds-tokens/color";import{Children as r,cloneElement as i}from"react";import c from"styled-components";const l=c.nav.withConfig({displayName:"StyledNav",componentId:"VDS__sc-hdba2y-0"})`
  display: block;
  font-weight: 400;
  font-style: normal;
  color: ${e.elements.primary.onlight.value};
  line-height: 1.25;
`,o=c.ol.withConfig({displayName:"StyledBreadcrumbList",componentId:"VDS__sc-hdba2y-1"})`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 0;
  list-style-type: decimal;
  margin: 0;
`,n=function(t){const{"data-analyticstrack":e,"data-track":c,"data-track-ignore":n,"data-clickstream":s}=t;return a(l,{id:t.id,"data-analyticstrack":e,"data-track":c,"data-track-ignore":n,"data-clickstream":s,"aria-label":t.ariaLabel,children:a(o,{children:function(){const{children:a,surface:e}=t,c=r.count(a);return r.map(a,(function(a,t){return i(a,0===t?{surface:e,firstChild:!0}:t===c-1?{surface:e,selected:!1!==a.props.selected||a.props.selected,lastChild:!0}:{surface:e})}))}()})})};n.defaultProps={surface:"light",ariaLabel:"Breadcrumb"};var s=t(n);export{s as default};
